export function normalizeSearch(search?: string) {
  return (search ?? '').trim().toLowerCase();
}
export function applySearch<T>(items: T[], search: string | undefined, fields: (keyof T)[]) {
  const normalized = normalizeSearch(search);
  if (!normalized || fields.length === 0) {
    return items;
  }
  return items.filter((item) =>
    fields.some((field) => {
      const value = item[field];
      if (value == null) {
        return false;
      }
      return String(value).toLowerCase().includes(normalized);
    }),
  );
}
export function applySort<T>(items: T[], sortBy?: keyof T | null, sortOrder?: 'asc' | 'desc') {
  if (!sortBy) {
    return items;
  }
  const direction = sortOrder === 'asc' ? 1 : -1;
  return [...items].sort((a, b) => {
    const left = a[sortBy];
    const right = b[sortBy];
    if (left == null && right == null) {
      return 0;
    }
    if (left == null) {
      return 1;
    }
    if (right == null) {
      return -1;
    }
    if (typeof left === 'number' && typeof right === 'number') {
      return (left - right) * direction;
    }
    return String(left).localeCompare(String(right)) * direction;
  });
}
export function paginate<T>(items: T[], limit = 25, offset = 0) {
  return {
    data: items.slice(offset, offset + limit),
    meta: {
      total: items.length,
      limit,
      offset,
    },
  };
}
